<div class="flex justify-between py-4">
    <div class="flex flex-column">
        <b>{{ partnerName }}</b>
        <span>{{ postalCode }} {{ city }}</span>
        <span>{{ street }}</span>
    </div>
    <div class="flex flex-column">
        <span>{{ partnerNumber }}</span>
        <span>{{ salesOrganization }}</span>
        <span>{{ salesChannel }}</span>
    </div>
</div>
